export * from './GeneralInformation'
export * from './GeneralInformationProps'
